import { useQuery } from '@tanstack/react-query';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { getBannersApi } from '@flipster/apis/v1/banner';
import { BannerParams } from '@flipster/apis/v1/banner/types';

import { authBunja } from '../shared/auth/state';

const useBanners = <T extends BannerParams>(params: T) => {
  const { isCookieLoggedInAtom } = useBunja(authBunja);
  const isCookieLoggedIn = useAtomValue(isCookieLoggedInAtom);
  const { data: banners, isLoading } = useQuery({
    queryKey: ['getBannersApi', isCookieLoggedIn, params],
    queryFn: () => getBannersApi(params),
    select: (response) => response.data,
  });

  return {
    banners,
    isLoading,
  };
};

export default useBanners;
